import { jsonrepair } from 'jsonrepair';
import customParseIncompleteJSON from './_custom-parse-incomplete-JSON.js';

export default (jsonString) => {
  if (!jsonString) {
    return null;
  }

  jsonString = jsonString.replaceAll("\\\\'", '’');
  jsonString = jsonString.replaceAll("\\\'", '’'); // eslint-disable-line no-useless-escape
  jsonString = jsonString.replaceAll("\\'", '’');

  try {
    const repaired = jsonrepair(jsonString);

    if (jsonString.startsWith('{') && repaired.startsWith('[')) {
      throw new Error('Invalid JSON structure');
    }

    return JSON.parse(repaired);
  } catch {
    console.log('customParseIncompleteJSON');

    const result = customParseIncompleteJSON(jsonString);

    console.log('result', result);
    if (Object.keys(result?.parsed || {}).length === 0 && (result?.incomplete?.length || result?.errors?.length)) {
      throw new Error(`Invalid JSON: ${JSON.stringify({ incomplete: result?.incomplete, errors: result?.errors })}`);
    }

    return result?.parsed;
  }
};
